import { render, staticRenderFns } from "./SellerCustomerIndex.vue?vue&type=template&id=5abc3984"
import script from "./SellerCustomerIndex.vue?vue&type=script&lang=js"
export * from "./SellerCustomerIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports